import { Link, LinkProps } from '@backstage/core-components';

import { ResourcePathArgs, useResourcePath } from '../../hooks/useResourcePath';

// `to` is derived from the route ref, so it is not part of the public props.
type ResourceLinkProps = Omit<LinkProps, 'to'> & ResourcePathArgs;

export const ResourceLink = ({
  routeRef,
  name,
  children,
  params,
  ...linkProps
}: ResourceLinkProps) => {
  const path = useResourcePath({ routeRef, name, params });

  if (!path) {
    return <>{children}</>;
  }

  return (
    <Link to={path} {...linkProps}>
      {children}
    </Link>
  );
};
